import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/UserAccountBalanceReport/UserAccountBalanceReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingUserAccountBalanceReportActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/UserAccountBalanceReport/UserAccountBalanceReport")
	}

	render() {
		return (
			<Activity 
				name="UserAccountBalanceReport"
				RenderedComponent={this.RenderedComponent}
				context="UserAccountBalanceReport"
				action="UserAccountBalanceReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingUserAccountBalanceReportActivity)
